import { render, staticRenderFns } from "./WithdrawManage.vue?vue&type=template&id=60b3ed5d&"
import script from "./WithdrawManage.vue?vue&type=script&lang=js&"
export * from "./WithdrawManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports